<template>
  <div class="main-content">
    <!-- 标题内容部分 -->
    <div class="title-content">
      <span>人工抄表</span>
      <van-icon name="cross" />
    </div>
    <!-- 基本信息部分 -->
    <div class="info-content">
      <div>基本信息</div>
      <a-form-model ref="formOption" :model="formOption" :rules="formRules" :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }">
        <div class="text-content">
          <span>房屋/范围：</span>
          <span>华瀚科技园/A栋/11楼/1103</span>
        </div>
        <div class="text-content">
          <span>仪表名称：</span>
          <span>普通电表</span>
        </div>
        <div class="text-content">
          <span>仪表编号：</span>
          <span>-</span>
        </div>
        <div class="require-option">
          <a-form-model-item label="抄表读数：" prop="currentValue">
            <a-input
              v-model="formOption.currentValue"
              placeholder="请填写抄表读数"
            />
          </a-form-model-item>
        </div>
        <div class="require-option">
          <a-form-model-item label="抄表日期：" prop="date">
            <a-date-picker
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="请选择抄表日期"
              v-model="formOption.date"
              :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
            />
          </a-form-model-item>
        </div>
      </a-form-model>
    </div>
    <!-- 底部按钮部分 -->
    <div class="bottom-btn">
        <a-button type="default" style="margin-left:3%;">取消</a-button>
        <a-button type="primary" @click="submitForm" style="margin-left:3%;">确定</a-button>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import 'moment/locale/zh-cn';
import { newCopyTable } from '@/axios/services'
export default {
  name: "CopyTable",
  data() {
    return {
      formOption: {
        currentValue: '',
        date: ''
      },
      formRules: {
        currentValue: [
          {
            required: true,
            message: "请填写抄表读数",
            trigger: "blur",
          },
        ],
        date: [
          {
            required: true,
            message: "请选择抄表日期",
            trigger: "change",
          },
        ],
      },
      showCalendar: false, // 日期组件
    };
  },
  methods: {
    moment,
    submitForm(){ // 点击确定提交表单
      let that = this
      this.$refs.formOption.validate((valid) => {
        if (valid) {
          let data = {
            instrumentationId: '', // 仪表ID
            currentValue: this.formOption.currentValue, // 抄表值
            meterReadingDate: this.formOption.date._d.toLocaleString('chinese',{hour12:false}) // 抄表日期
          }
          newCopyTable(data).then((res) => {
            console.log(res)
            let responseData = res.data
            if (responseData.code == 0) {
              that.$message.success("新增成功");
              that.basicSet = false;
              that.getData()
            } else {
              that.$message.error("操作失败," + responseData.msg);
            }
          });
        }
      })
    },
  },
};
</script>
<style scoped>
.main-content{
  width: 100%;
  height: 100vh;
  background-color: white;
  position: relative;
}
.main-content .title-content{
  width: 100%;
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #ccc;
}
.title-content span{
  margin-right: auto;
  color: #333;
  font-weight: 700;
}
.info-content{
  width: 100%;
  padding: 15px 20px;
}
.info-content>div:nth-child(1){
  color: #333;
  font-weight: 700;
  margin-bottom: 3%;
}
.info-content .text-content{
  margin-left: 3%;
  line-height: 1rem;
}
.info-content .text-content span:nth-child(1){
  display: inline-block;
  width: 24%;
  text-align: right;
}
.require-option /deep/.ant-form-item{
  display:flex;
}
.require-option /deep/.ant-form-item-label{
  width:auto;
  padding:0;
  margin-top:2.5%;
  margin-left:2%;
  margin-right:3%;
}
.require-option /deep/.ant-form-item-control-wrapper{
  width:auto;
}
.bottom-btn{
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: right;
  border-top: 1px solid #ccc;
  padding: 3%;
}
</style>